/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useCallback } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useLazyQuery,
} from '@apollo/react-hooks';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { useIsAllowedToCreateWhiteboard } from '@confluence/content-types-utils/entry-points/useIsAllowedToCreateWhiteboard.ts';

import type { usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery as usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$data } from './__types__/usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery.ts';

const usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = gql`
	query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery {
		paywallContentToDisable(contentType: "whiteboard") {
			deactivationIdentifier
			link
			title
		}
	}
`;
type UsePreloadCreationMenuDataResponse = () => void;
export const usePreloadCreationMenuData = (): UsePreloadCreationMenuDataResponse => {
	const { edition } = useSessionData();
	const isPremium = edition === ConfluenceEdition.PREMIUM;

	const isAllowedToCreateWhiteboard = useIsAllowedToCreateWhiteboard();
	const [preloadWhiteboardPaywallData] =
		useLazyQuery<usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$data>(
			usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery,
		);
	const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
	return useCallback(() => {
		if (shouldPreloadPaywallData) {
			preloadWhiteboardPaywallData();
		}
	}, [preloadWhiteboardPaywallData, shouldPreloadPaywallData]);
};
